/**
 * Componente principal con ConfigProvider de Ant Design (color #791ea3), AppRoutes y modal de versión.
 */
import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import esES from "antd/locale/es_ES";
import AppRoutes from "components/routes/AppRoutes";
import SpinOneFIN from "components/spinOneFIN/SpinOneFIN";
import { useAuth } from "AuthContext";
import AppVersionModal from "components/modalVersion/AppVersionModal";
import { useAppVersion } from "hooks/useAppVersion";
import ErrorBoundary from "components/ErrorBoundary";
import "App.css";

const App = () => {
  const { loading, loggedUser, decodedUser } = useAuth();
  const { showUpdateModal, handleUpdate, backendVerfro, backendVerbac } = useAppVersion();

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const currentFavicon = document.getElementById("favicon");
    if (!mediaQuery.matches) {
      currentFavicon.href = "/favicon.ico";
    } else {
      currentFavicon.href = "/favicon_blanco.ico";
    }
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <SpinOneFIN />
      </div>
    );
  }

  return (
    <ConfigProvider locale={esES} theme={{ token: { colorPrimary: "#791ea3" } }}>
      {!["onefinqa.innercor.com.ar", "localhost"].includes(window.location.hostname) && (
        <AppVersionModal
          visible={showUpdateModal}
          onConfirm={handleUpdate}
          frontVersion={backendVerfro}
          backVersion={backendVerbac}
        />
      )}
      <ErrorBoundary>
        <AppRoutes loggedUser={loggedUser} decodedUser={decodedUser} />
      </ErrorBoundary>
    </ConfigProvider>
  );
};

export default App;
